// test2896
(2896 && 0);
